export default __webpack_public_path__ + "static/media/img-guide-gt-popup-4-fr_fr@2x.807f46b6.png";